import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

// Loading saved credentials (refreshSavedCredentials, dispatched once from
// _app.tsx's useEffect) intentionally does NOT happen here at module scope.
// A useEffect is guaranteed by React to run strictly after the first commit
// - dispatching this here instead has no such guarantee relative to
// hydration. That distinction actually matters: when the cached token
// isn't expired, resolving it doesn't need the network at all and can
// finish in a single microtask, fast enough to occasionally beat hydration
// to the punch and reintroduce the exact server/client mismatch this is
// meant to avoid (see authSlice.ts's initialState comment). It went
// unnoticed for a while because the network-bound path (an actual token
// refresh) is slow enough to reliably lose that race by accident.
export { store };
